import { renderRoutes } from 'react-router-config'

import Home from './Home'
import AddCustomer from './AddCustomer'
import Print from './Print'
import Root from './Root'
import Login from './Login'

const routes = [
  {
    component: Root,
    routes: [
      {
        component: Home,
        exact: true,
        path: '/'
      },
      {
        component: Login,
        path: '/login'
      },
      {
        component: AddCustomer,
        path: '/add'
      },
      {
        component: Print,
        path: '/print'
      }
    ]
  }
]

export default () => renderRoutes(routes)



// WEBPACK FOOTER //
// ./src/routes/index.js